import DataTileClass, * as DataTileModule from './../../node_modules/ol/source/DataTile.js';

class DataTile extends DataTileClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in DataTileModule) {
    if (key !== "default") {
        DataTile[key] = DataTileModule[key];
    }
}

export default DataTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/DataTile.js';